import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { WebhookDeliveryType, WebhookEndpointType } from '@/types/invoiceVaultTypes';

export type WebhookPayloadType = { url: string; description?: string; events: string[]; is_active?: boolean };
export type WebhookCreatedType = WebhookEndpointType & { secret: string };

export const getWebhooksApi = (): Promise<ApiResponseType<{ results: WebhookEndpointType[]; events: string[] }>> =>
  authApiService.GET('/invoice-vault/webhooks/');
export const createWebhookApi = (payload: WebhookPayloadType): Promise<ApiResponseType<WebhookCreatedType>> =>
  authApiService.POST('/invoice-vault/webhooks/', payload);
export const updateWebhookApi = (
  id: string,
  payload: WebhookPayloadType
): Promise<ApiResponseType<WebhookEndpointType>> => authApiService.PATCH(`/invoice-vault/webhooks/${id}/`, payload);
export const deleteWebhookApi = (id: string): Promise<ApiResponseType<null>> =>
  authApiService.DELETE(`/invoice-vault/webhooks/${id}/`);
export const rotateWebhookSecretApi = (id: string): Promise<ApiResponseType<WebhookCreatedType>> =>
  authApiService.POST(`/invoice-vault/webhooks/${id}/rotate-secret/`, {});
export const getWebhookDeliveriesApi = (id: string): Promise<ApiResponseType<{ results: WebhookDeliveryType[] }>> =>
  authApiService.GET(`/invoice-vault/webhooks/${id}/deliveries/`);
